import React, { useState } from "react"
import types from "prop-types"
import clsx from "clsx"
import { questionShape } from "utils/propTypeShapes"
import { FormsyListMultiSelect } from "shared/multiSelects"
import { FormsyCheckboxGroup } from "shared/checkboxes"
import { DROPDOWN } from "FormBuilder/QuestionFields/QuestionTypeAttributes/SelectAttributes/DisplayAs"

const MultiSelectAnswerField = ({
  question,
  initialValue = [],
  disabled = false,
  className = "",
  placeholder = "",
  hasBaseInputStyle = false,
  isFullWidth = false,
  edit = false,
  isTaskForm = false,
}) => {
  const { required, uuid, attributes } = question
  const {
    columnCount,
    defaultAnswers,
    displayAs,
    options,
  } = attributes

  const isNewFormSubmission = !edit && !isTaskForm
  initialValue = isNewFormSubmission ? defaultAnswers : initialValue

  // Needed for now-deleted options if user de-selects and wants to re-select while editing
  const [originalValue] = useState(initialValue)

  let validations = null

  if (!edit) {
    validations = required ? { isNotEmptyArray: true } : null
  }

  const value = initialValue

  const answersAreNotOptions = value.filter((answer) => !options.includes(answer))
  const isPlural = answersAreNotOptions.length > 1

  const originalValuesAreNotOptions = originalValue.filter((answer) => !options.includes(answer))
  const optionsToChooseFrom = originalValuesAreNotOptions.length
    ? [...options, ...originalValuesAreNotOptions]
    : options

  const deletedOptionsMessage = answersAreNotOptions.length > 0 && (
    <p className="text-sm">
      {isPlural ? "The following saved answers" : "The following saved answer"} for this question {isPlural ? "are" : "is"} no longer {isPlural ? "options" : "an option"}: <span className="font-semibold">{answersAreNotOptions.join(", ")}</span>.
    </p>
  )

  return (
    <>
      {
        displayAs === DROPDOWN
          ? (
            // Must pass value prop for Formsy to register the value
            // Pass values prop for the component to find the selected options
            <FormsyListMultiSelect
              className={clsx("form-input", answersAreNotOptions.length > 0 && "mb-4", className)}
              searchable
              disabled={disabled}
              hasBaseInputStyle={hasBaseInputStyle}
              placeholder={placeholder}
              name={uuid}
              isFullWidth={isFullWidth}
              options={optionsToChooseFrom}
              value={value}
              values={disabled ? [] : value}
              validations={validations}
            />
          )
          : (
            <FormsyCheckboxGroup
              className={clsx("my-3 text-lg", answersAreNotOptions.length > 0 && "mb-4", className)}
              name={uuid}
              disabled={disabled}
              checkboxInputClassName="form-hover-highlight"
              options={optionsToChooseFrom}
              value={disabled ? [] : value}
              columnCount={columnCount}
              validations={validations}
            />
          )
      }
      {deletedOptionsMessage}
    </>
  )
}

MultiSelectAnswerField.propTypes = {
  question: questionShape.isRequired,
  initialValue: types.arrayOf(types.string),
  disabled: types.bool,
  className: types.string,
  placeholder: types.string,
  hasBaseInputStyle: types.bool,
  isFullWidth: types.bool,
  edit: types.bool,
  isTaskForm: types.bool,
}

export default MultiSelectAnswerField
